import React from 'react';

const AccountVerification = () => (
  <section className="py-2 px-4 bg-gray-100">
    {/* <h2 className="text-3xl font-semibold text-center text-gray-800 mb-6">Purchase Dashboard</h2> */}
    <h4 className='text-1xl font-semibold m-1'>Account Verification</h4>
    <div className="max-w-6xl mx-auto shadow-lg border border-gray-200 rounded-lg overflow-hidden">
      <iframe
        title="Purchase Dashboard"
        width="100%"
        height="600"
        src="https://app.powerbi.com/view?r=eyJrIjoiZGJjYTcyODctZWU5Yy00ZmZkLTllZmEtNjA1ZjFhOWMxYWE1IiwidCI6IjhjMDYwZTQzLTM1MTEtNGIwZC1iZGI1LTg4NTA2ZmExYmI2MyJ9"
        allowFullScreen
        className="w-full"
      ></iframe>
    </div>
  </section>
);

export default AccountVerification;
